<div class="tile">
    <div class="img">
        <img [src]="TileWidgetConfiguration.ImageUrl" alt="{{ TileWidgetConfiguration.HeaderResourceId | transloco }}" />
    </div>
    <div class="tile-content">
        <h4>{{ TileWidgetConfiguration.HeaderResourceId | transloco }}</h4>
        <span>{{ TileWidgetConfiguration.ContentResourceId | transloco }}</span>
    </div>
</div>